import { render } from "./AiSelectedModel.vue?vue&type=template&id=6eec585e&scoped=true"
import script from "./AiSelectedModel.vue?vue&type=script&lang=js"
export * from "./AiSelectedModel.vue?vue&type=script&lang=js"

import "./AiSelectedModel.vue?vue&type=style&index=0&id=6eec585e&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eec585e"],['__file',"src/Components/ChatWidget/AssistantAi/AiComponents/AiSelectedModel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6eec585e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6eec585e', __exports__)) {
    api.reload('6eec585e', __exports__)
  }
  
  module.hot.accept("./AiSelectedModel.vue?vue&type=template&id=6eec585e&scoped=true", () => {
    api.rerender('6eec585e', render)
  })

}


export default __exports__